<template>
  <b-container>
    <b-modal
      id="modal-scrollable"
      class="detailedFilter-modal"
      body-class="scrollPendency"
      scrollable
      size="lg"
      ref="openModal"
      :title="$t('geral.detailedFilter')"
    >
      <checklist-filled-details
        ref="scrollToPage"
        :id="id"
        :fieldId="fieldId"
        :showBackToList="false"
        @scroll-page="scrollPage"
      ></checklist-filled-details>

      <template #modal-footer="{ ok }">
        <div style="text-align: right; width: 100%">
          <b-button variant="danger" @click="ok()">
            {{ $t("geral.close") }}
          </b-button>
        </div>
      </template>
    </b-modal>
  </b-container>
</template>
<script>
import Vue from "vue";
import VueScrollTo from "vue-scrollto";
Vue.use(VueScrollTo);
export default {
  name: "PedencyFieldDetailsModal",
  props: {
    id: String,
    fieldId: Number,
  },
  components: {
    'checklist-filled-details': () =>
      import("@/pagesRms/checklist/checklist/ChecklistFilledDatails.vue"),
  },
  data() {
    return {};
  },
  methods: {
    open() {
      this.$refs.openModal.show();
    },
    scrollPage() {
      const sleep = (milliseconds) => {
        return new Promise((resolve) => setTimeout(resolve, milliseconds));
      };

      const doSomething = async () => {
        await sleep(200);
        var options = {
          container: ".scrollPendency",
          easing: "ease-in-out",
          offset: -10,
          force: true,
          lazy: true,
          cancelable: true,
          x: false,
          y: true,
        };
        console.log("#input" + this.fieldId);
        VueScrollTo.scrollTo("#input" + this.fieldId, 500, options);
      };

      doSomething();
    },
  },
};
</script>
